import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import QuiSommesNous from "@/pages/QuiSommesNous";
import Contact from "@/pages/Contact";
import DemandeDevis from "@/pages/DemandeDevis";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/qui-nous-sommes" element={<QuiSommesNous />} />
          <Route path="/que-faisons-nous" element={<Navigate to="/#services" replace />} />
          <Route path="/nous-contacter" element={<Contact />} />
          <Route path="/demande-devis" element={<DemandeDevis />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
